import { ThemeComponent } from '@/theme/ThemeComponent';
import { OptionSelector } from '@/utils/OptionSelectors';
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ProductOption } from '@/components/Product/ProductOptionPicker';

interface ValueRadio extends HTMLInputElement {
    dataset: {
        value: string;
    };
}

@Component
export class ProductButtonOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop selected!: string;
    @Prop position!: number;

    @Ref buttonItem!: HTMLElement[];
    @Ref({ required: false }) labelSelectedOption?: HTMLElement;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string|null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {

        this.updateButtonStyles();

        // Listen for button change
        for (const buttonItem of this.buttonItem) {
            const button = buttonItem.querySelector('input') as ValueRadio;
            this.$listen(button, 'change', () => {

                // Do not continue if already checked
                if (!button.checked) { return; }

                // Get and select value
                const value = button.value;
                this.select(value);

                // Update label selected value
                if (this.labelSelectedOption && value) {
                    this.labelSelectedOption.textContent = value;
                }

                // Dispatch change event
                this._onChange.dispatch(value);
            });
        }
    }

    public select(value: string) {
        this.selected = value;
        this.updateButtonStyles();
    }

    public updateSelectedValueText() {
        if (this.labelSelectedOption) {
            this.labelSelectedOption.textContent = this.selected;
        }
    }

    public updateBasedOnSelector(selector: OptionSelector) {

        // Define array of out of stock values
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);

        // Define array of no variant values
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);
    }

    public updateButtonStyles() {

        // Loop through
        for (const buttonItem of this.buttonItem) {

            // Get input and selected value
            const input = buttonItem.querySelector('input') as ValueRadio;
            const value = input.value;

            // Is this the selected button?
            const selected = (value || null) == this.selected;

            // Check value against out of stock and no variant data
            const outOfStock = this.valuesWithoutStock.indexOf(value) > -1;
            const noVariant = this.valuesWithoutVariant.indexOf(value) > -1;

            // Remove all dynamic classes
            buttonItem.classList.remove(
                'is-active',
                'product-button-option__button-item--no-variant',
                'product-button-option__button-item--sold-out'
            );

            // No variant class conditional
            if (noVariant) {
                buttonItem.classList.add('product-button-option__button-item--no-variant');
                return;
            }

            // Selected class conditional
            if (selected) {
                buttonItem.classList.add('is-active');
            }

            // Out of stock class conditional
            if (outOfStock) {
                buttonItem.classList.add('product-button-option__button-item--sold-out');
            }
        }
    }
}
